import React from "react";
import { useTheme } from "../../lib/ThemeContext";

/**
 * Hero portrait. Both versions are layered and crossfade via opacity when the
 * theme changes. Images live in /public so they travel with the code when
 * self-hosted.
 */
export const Portrait = () => {
    const { theme } = useTheme();

    return (
        <div className="relative w-full">
            <div className="relative border-hard-3 bg-[var(--surface)] overflow-hidden">
                {/* Corner mono tick */}
                <div className="absolute z-20 bottom-3 left-3 mono-meta !text-[10px] tracking-widest text-[#c7c7c7]">
                    MANAS · B
                </div>

                {/* Spotlight */}
                <div className="absolute inset-0 spotlight z-10 pointer-events-none" />

                {/* Portrait — vertical 4:5, opacity crossfade */}
                <div className="relative aspect-[4/5] w-full bg-[var(--page)]">
                    <img
                        src="/hero-light.webp"
                        alt={theme === "light" ? "Manas Bhansali" : ""}
                        aria-hidden={theme !== "light"}
                        loading="eager"
                        decoding="async"
                        className="absolute inset-0 w-full h-full object-cover object-top transition-opacity duration-700 ease-out"
                        style={{ opacity: theme === "light" ? 1 : 0 }}
                    />
                    <img
                        src="/hero-dark.webp"
                        alt={theme === "dark" ? "Manas Bhansali" : ""}
                        aria-hidden={theme !== "dark"}
                        loading="eager"
                        decoding="async"
                        className="absolute inset-0 w-full h-full object-cover object-top transition-opacity duration-700 ease-out"
                        style={{ opacity: theme === "dark" ? 1 : 0 }}
                    />
                </div>
            </div>
        </div>
    );
};
